var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "mt-12",
    attrs: {
      "align": "center",
      "justify": "center",
      "justify-md": "space-around"
    }
  }, [_c('v-col', {
    staticClass: "d-flex align-center justify-center mt-6 mt-lg-0 pa-1",
    attrs: {
      "cols": "12",
      "sm": "10",
      "md": "5",
      "xl": "3",
      "align-self": "stretch"
    }
  }, [_c('feature-card', {
    staticClass: "ma-0 ma-sm-4 ma-lg-8 ma-xl-0",
    attrs: {
      "cardProps": {
        to: '/services/library-of-things'
      },
      "cardActionsProps": {
        class: 'd-flex justify-center align-center mt-auto'
      },
      "cardTextProps": {
        class: 'd-flex flex-column'
      },
      "imageSrc": "https://media.eipl.org/site/images/pages/home/library-of-things.jpg",
      "titleText": "LIBRARY OF THINGS"
    },
    scopedSlots: _vm._u([{
      key: "card-text",
      fn: function () {
        return [_c('v-sheet', {
          staticClass: "d-flex align-center justify-center text-h6 primary--text font-weight-bold"
        }, [_c('span', [_vm._v("BORROW")]), _c('span', {
          staticClass: "mx-4"
        }, [_vm._v("•")]), _c('span', [_vm._v("USE")]), _c('span', {
          staticClass: "mx-4"
        }, [_vm._v("•")]), _c('span', [_vm._v("RETURN")])]), _c('p', {
          staticClass: "text-body-1 primary--text my-auto pa-4"
        }, [_vm._v(" Choose from a wide selection of devices, equipment and lawn games including; Auto Code Reader, Cricut, Digital Film Scanner, Karaoke Machine, Metal Detector, Sewing Machine, Telescope, Wi-Fi Hotspots,Badminton, Bean Bag Bucketz, Bocce, Cornhole, Croquet, Four in a Row, Four to Score, Jenga, Kan Jam, Ladder Toss, Ring Toss, Spikeball and much more. ")])];
      },
      proxy: true
    }, {
      key: "card-actions",
      fn: function () {
        return [_c('p', {
          staticClass: "text-body-1 primary--text text-center font-weight-bold mb-0"
        }, [_vm._v("Reserve Today For Parties & Events!")])];
      },
      proxy: true
    }])
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center justify-center mt-6 mt-lg-0 pa-1",
    attrs: {
      "cols": "12",
      "sm": "10",
      "md": "5",
      "xl": "3",
      "align-self": "stretch"
    }
  }, [_c('feature-card', {
    staticClass: "ma-0 ma-sm-4 ma-lg-8 ma-xl-0",
    attrs: {
      "cardProps": {
        to: '/services/maker-lab'
      },
      "imageSrc": "https://media.eipl.org/site/images/pages/home/maker-lab.jpg",
      "cardTextProps": {
        class: 'd-flex flex-column align-start justify-space-around'
      },
      "titleText": "MAKERLAB"
    },
    scopedSlots: _vm._u([{
      key: "card-text",
      fn: function () {
        return [_c('p', {
          staticClass: "primary--text text-body-1"
        }, [_c('span', {
          staticClass: "text-body-1 font-weight-bold"
        }, [_vm._v("Design & Create:")]), _vm._v(" mugs, T-shirts, coasters, crafts, buttons, 3D printing, fun labels, and more. ")]), _c('p', {
          staticClass: "primary--text text-body-1"
        }, [_c('span', {
          staticClass: "text-body-1 font-weight-bold"
        }, [_vm._v("Equipment:")]), _vm._v(" green screen, virtual reality, 3D printers, Cricut (printer, mug press, easy press), and computers with design, audio production, and more ")])];
      },
      proxy: true
    }])
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center justify-center mt-6 mt-lg-14 ma-xl-0 pa-1",
    attrs: {
      "cols": "12",
      "sm": "10",
      "md": "5",
      "xl": "3",
      "align-self": "stretch"
    }
  }, [_c('feature-card', {
    staticClass: "ma-0 ma-sm-4 ma-lg-8 ma-xl-0",
    attrs: {
      "cardProps": {
        to: '/services/museum-passes'
      },
      "cardActionsProps": {
        class: 'd-flex align-center justify-space-around'
      },
      "cardTextProps": {
        class: 'd-flex flex-column align-start justify-space-around'
      },
      "imageSrc": "https://media.eipl.org/site/images/pages/home/museum-passes.jpg",
      "titleText": "MUSEUM PASSES & <br /> DISCOUNT TICKETS"
    },
    scopedSlots: _vm._u([{
      key: "card-text",
      fn: function () {
        return [_c('p', {
          staticClass: "primary--text text-body-1 font-weight-bold"
        }, [_vm._v(" The library offers a variety of free passes and discounted tickets to some of New York's most popular museums, parks and attractions. ")]), _c('p', {
          staticClass: "primary--text text-body-1 font-weight-bold"
        }, [_vm._v("Explore all our offered oppurtunities before planning your next day out!")])];
      },
      proxy: true
    }, {
      key: "card-actions",
      fn: function () {
        return [_c('v-btn', {
          staticClass: "mb-2",
          attrs: {
            "color": "primary",
            "large": "",
            "to": "/services/museum-passes",
            "width": "40%"
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-bank")]), _vm._v("PASSES")], 1), _c('v-btn', {
          staticClass: "mb-2",
          attrs: {
            "color": "primary",
            "large": "",
            "to": "/services/discount-tickets",
            "width": "40%"
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-ticket")]), _vm._v("TICKETS")], 1)];
      },
      proxy: true
    }])
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center justify-center mt-6 mt-lg-14 ma-xl-0 pa-1",
    attrs: {
      "cols": "12",
      "sm": "10",
      "md": "5",
      "xl": "3",
      "align-self": "stretch"
    }
  }, [_c('feature-card', {
    staticClass: "ma-0 ma-sm-4 ma-lg-8 ma-xl-0",
    attrs: {
      "cardProps": {
        to: '/digital-resources'
      },
      "cardTextProps": {
        class: 'd-flex flex-column align-start justify-space-around'
      },
      "imageSrc": "https://media.eipl.org/site/images/pages/home/digital-library.jpg",
      "titleText": "DIGITAL LIBRARY"
    },
    scopedSlots: _vm._u([{
      key: "card-text",
      fn: function () {
        return [_c('p', {
          staticClass: "primary--text text-body-1 font-weight-bold"
        }, [_vm._v("Enjoy everything the library has to offer and more from the comfort of your own devices!")]), _c('p', {
          staticClass: "primary--text text-body-1 font-weight-bold"
        }, [_vm._v(" Browse a wide variety of media through our catalog and partnered services including E-Books, E-Magazines, Audio Books, Movies, Music and more. ")])];
      },
      proxy: true
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }